export function validateEmailFormat(email: string): boolean {
    const regex =
        /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

    return email.slice(0, email.indexOf('@')).length < 64 && !!email.toLowerCase().match(regex)
}
